const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.all_shared_models/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.all_shared_models/LIST_ALL_SHARED_MODELS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };

    case 'table.all_shared_models/LIST_ALL_SHARED_MODELS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };

    default:
      return state;
  }
}
